import Service from "../../AuthService";
const factoryEmployee = {
    getFactoryEmployee(page,data){
        return Service.get(`/factory_employee?page=${page}`+
            `&factory_id=${data.factory_id}&date_start=${data.date_start}&date_end=${data.date_end}`
        );
    },
    showFactoryEmployee(id){
        return Service.get('/factory_employee/'+id);
    },
    createFactoryEmployee(data){
        return Service.post('/factory_employee',data);
    },
    updateFactoryEmployee(id,data){
        return Service.put('/factory_employee/'+id,data);
    },
    deleteFactoryEmployee(id){
        return Service.delete('/factory_employee/'+id);
    },
    getAllFactoryEmployee(){
        return Service.get('/factory_employee_all');
    },
    delete(id){
        return Service.get('/factory_employee_delete?id='+id);
    },
}
export default factoryEmployee
